import { render, staticRenderFns } from "./Wallpaper.vue?vue&type=template&id=7fba59f2&scoped=true"
import script from "./Wallpaper.vue?vue&type=script&lang=js"
export * from "./Wallpaper.vue?vue&type=script&lang=js"
import style0 from "./Wallpaper.vue?vue&type=style&index=0&id=7fba59f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fba59f2",
  null
  
)

export default component.exports